import { fetchUtils } from 'react-admin'
import axios from 'axios'
import { stringify } from 'query-string'
import { getJWT } from '../helper/localStore/getJWT'
import { objectToQueryString } from 'src/helper/objectToQueryString'
const httpClient = fetchUtils.fetchJson

const API_BASE_URL = process.env.REACT_APP_URL_OPERATION_BFF || 'http://localhost:8001'

const OperationBffProvider = {
  getList: async (resource, params) => {
    const { page, perPage } = params.pagination
    const { field, order } = params.sort
    const filters = params.filter || {}

    const query = {
      page: page,
      page_size: perPage,
    }

    if (field) {
      query['order_by'] = field
      query['order_type'] = order?.toLowerCase() || 'desc'
    }

    const addFilters = (filter) => {
      if (filter && Object.keys(filter).length > 0) {
        return '&' + objectToQueryString(filter)
      }
      return ''
    }

    const url = `${API_BASE_URL}/api/reports/operations?${stringify(query)}${addFilters(filters)}`

    try {
      const response = await axios.get(url, {
        headers: {
          'authentication-token': getJWT(),
        },
      })

      const transformData = (data) => {
        return (
          data?.map((row) => ({
            ...row,
            id: row.hash_operation,
            reservation_id: row.b2_internal_number,
          })) || []
        )
      }

      const pagination = response.data?.pagination || {}

      return {
        data: transformData(response.data?.data || []),
        total: pagination.total_items || 0,
      }
    } catch (error) {
      console.log('error', error)
      localStorage.removeItem(`RaStore.operation-bff.listParams`)
      throw new Error('Error fetching operations')
    }
  },

  getOne: async (resource, params) => {
    const url = `${API_BASE_URL}/api/reports/operations/${params.id}`

    try {
      const response = await axios.get(url, {
        headers: {
          'authentication-token': getJWT(),
        },
      })

      const data = response.data?.data || response.data

      return {
        data: {
          ...data,
          id: data?.hash_operation,
        },
      }
    } catch (error) {
      console.log('error', error)
      throw new Error('Error fetching operation')
    }
  },

  update: (resource, params) =>
    httpClient(`${process.env.REACT_APP_URL_BUCKET}/${resource}/${params.id}`, {
      method: 'PUT',
      body: JSON.stringify(params.data),
      headers: new Headers({ 'authentication-token': getJWT() }),
    }).then(({ json }) => ({ data: json })),

  create: (resource, params) =>
    httpClient(`${process.env.REACT_APP_URL_BUCKET}/${resource}/`, {
      method: 'POST',
      body: JSON.stringify(params.data),
      headers: new Headers({ 'authentication-token': getJWT() }),
    }).then(({ json }) => ({
      data: { ...params.data, id: json.id },
    })),

  getMany: (resource, params) => {
    return httpClient(
      `${process.env.REACT_APP_URL_BUCKET}/${resource}/?operator=or&id=${Object.values(
        params.ids
      ).toString()}`,
      {
        headers: new Headers({ 'authentication-token': getJWT() }),
      }
    ).then(({ json }) => {
      return { data: json }
    })
  },

  delete: (resource, params) =>
    httpClient(`${process.env.REACT_APP_URL_BUCKET}/${resource}/${params.id}`, {
      method: 'DELETE',
      headers: new Headers({ 'authentication-token': getJWT() }),
    }).then(({ json }) => ({ data: json })),
}

export default OperationBffProvider
